module.exports = __webpack_public_path__ + "media/sfx_chat_1.8b87d31c.mp3";